import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GraphSchemaComponent} from '../graph-schema/graph-schema.component';
import {CheckboxModule} from 'primeng/checkbox';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {TableUiService} from './table-ui.service';

const cmp = [
    GraphSchemaComponent
];

@NgModule({
    declarations: [
        ...cmp
    ],
    exports: [
        ...cmp
    ],
    imports: [
        CommonModule,
        ButtonModule,
        DialogModule,
        CheckboxModule
    ]
})
export class GraphSchemaModule {
}
